/**
 * Community 社区的状态管理
 */
import ROUTER from '../../router.js'
import { GET, URLS, POST, Utils, DELETE } from '../../utils'
import { types as TipTypes } from './tip'
import { types as ConfirmTypes } from './confirm'
import { types as LoadingTypes } from './loading'

export const types = {
  /**
   * 广告列表请求
   */
  FETCH_AD_LIST_DATA: 'VIDEO_COURSE/FETCH_AD_LIST_DATA',

  /**
   * 视频课程详情请求
   */
  FETCH_DETAIL_VIDEO_COURSE: 'VIDEO_COURSE/FETCH_DETAIL_VIDEO_COURSE',

  /**
   * 视频课程列表请求(分类)
   */
  FETCH_LIST_DATA_VIDEOS: 'VIDEO_COURSE/FETCH_LIST_DATA_VIDEOS',

  /**
   * 视频课程分类列表请求
   */
  FETCH_COURSE_VIDEOS_CATEGORYS: 'VIDEO_COURSE/FETCH_COURSE_VIDEOS_CATEGORYS',
  /**
   * 乐高视频分类列表请求
   */
  FETCH_LEGO_VIDEOS_CATEGORYS: 'VIDEO_COURSE/FETCH_LEGO_VIDEOS_CATEGORYS',
}

const state = {
  // 视频课程分类列表
  categorys:{
    page: 1,
    page_size: 10,
    data: [],
    load_more: false,
    total_count: 0
  },

  // 视频课程列表某分类下
  videos: {
    page: 1,
    page_size: 10,
    data: [],
    load_more: false,
    total_count: 0
  },

  current_ad: null,
}

const mutations = {
  set_load_more (state, param) {
    // param: {"value": true, "data_type":"member"}
    if(param.data_type === 'category'){
      state.categorys.load_more = param.value
    }else if(param.data_type === 'video'){
      state.videos.load_more = param.value
    }
  },
  set_pagenum (state, param) {
    // param: {"value": 3, "data_type":"member"}
    if(param.data_type === 'category'){
      state.categorys.page = param.value
    }else if(param.data_type === 'video'){
      state.videos.page = param.value
    }
  },
  set_list_data (state, param) {
    // param: {"data": [], "data_type":"member"}
    let temp_state = null;
    if(param.data_type === 'category'){
      temp_state = state.categorys
    }else if(param.data_type === 'video'){
      temp_state = state.videos
    }
    if(temp_state){
      if (temp_state.page === 1) {
        temp_state.data = param.data
      } else {
        temp_state.data = temp_state.data.concat(param.data)
      }
      temp_state.total_count = param.count
    }
  },

  // 更新浏览量
  update_list_data_for_browser(state, param){
    // param: {"pk": 1, "data_type":"game"}
    if (param.data_type === 'category') {
      state.categorys.data.map(item=>{
        let target_item = item.top_3_videos.find(videoItem => videoItem.id === param.pk)
        if(target_item){
          target_item['browser_count'] += 1
        }
      })
    } else if(param.data_type === 'video'){
      let target_item = state.videos.data.find(item => item.id === param.pk)
      if(target_item){
        target_item['browser_count'] += 1
      }
    }
  },

  set_current_ad(state, param){
    state.current_ad = param;
  }

}

const actions = {
  /**
   * 广告列表
   * @param {*} param {"page":1, "page_size":10}
   */
  [types.FETCH_AD_LIST_DATA] ({ commit, state }, param) {
    // param: {"page":1}
    // 打开等待动画
    commit(LoadingTypes.SHOW)
    
    let page = param.page ? param.page : 1
    let page_size = param.page_size ? param.page_size : 10
    let is_community = param.is_community ? param.is_community : 'False'
    let url = URLS.list_ad(page, page_size, is_community)

    GET(url).then(
      response => {
        // 更新 load_more
        if(response.results.length){
          commit("set_current_ad", response.results[0])
        }
        // 移除等待动画
        commit(LoadingTypes.HIDE)
      }
    )
  },

  /**
   * 课程详情
   * @param {*} param {"pk":1, types:'category/video'}
   */
  [types.FETCH_DETAIL_VIDEO_COURSE] ({ commit, state }, param) {
    // param: {"page":1}
    // 打开等待动画
    commit(LoadingTypes.SHOW)
    
    let temp_dic = {
      data_type: param.types
    }

    GET(URLS.course_video_detail(param.pk)) .then(
      response => {
        // 跟新数据源
        commit('update_list_data_for_browser', {
          ...temp_dic,
          pk: param.pk
        })

        // 移除等待动画
        commit(LoadingTypes.HIDE)
      }
    )
  },

  /**
   * 视频课程列表(某分类下)
   * @param {*} param {"page":1, "category_id":1}
   */
  [types.FETCH_LIST_DATA_VIDEOS] ({ commit, state }, param) {
    // param: {"page":1}
    // 打开等待动画
    commit(LoadingTypes.SHOW)
    let temp_dic = {
      data_type: "video"
    }
    commit('set_load_more', { ...temp_dic, value: false })
    commit('set_pagenum', { ...temp_dic, value: param.page })

    GET(URLS.course_videos(param.page, param.category_id)).then(
      response => {
        // 更新 load_more
        if (response.next) {
          commit('set_load_more', { ...temp_dic, value: true })
        } else {
          commit('set_load_more', { ...temp_dic, value: false })
        }

        // 跟新数据源
        commit('set_list_data', {
          ...temp_dic,
          data: response.results,
          count: response.count
        })

        // 移除等待动画
        commit(LoadingTypes.HIDE)
      }
    )
  },

  /**
   * 视频课程分类列表
   * @param {*} param {"page":1}
   */
  [types.FETCH_COURSE_VIDEOS_CATEGORYS] ({ commit, state }, param) {
    // param: {"page":1}
    // 打开等待动画
    commit(LoadingTypes.SHOW)
    let temp_dic = {
      data_type: "category"
    }

    GET(URLS.course_video_categorys).then(
      response => {

        // 跟新数据源
        commit('set_list_data', {
          ...temp_dic,
          data: response.results,
          count: response.count
        })

        // 移除等待动画
        commit(LoadingTypes.HIDE)
      }
    )
  },
  
  /**
   * 乐高课程分类列表
   * @param {*} param {"page":1}
   */
  [types.FETCH_LEGO_VIDEOS_CATEGORYS] ({ commit, state }, param) {
    // param: {"page":1}
    // 打开等待动画
    commit(LoadingTypes.SHOW)
    let temp_dic = {
      data_type: "category"
    }

    GET(URLS.lego_video_categorys).then(
      response => {

        // 跟新数据源
        commit('set_list_data', {
          ...temp_dic,
          data: response.results,
          count: response.count
        })

        // 移除等待动画
        commit(LoadingTypes.HIDE)
      }
    )
  },
}

const getters = {
  
}

export default {
  state,
  mutations,
  actions,
  getters
}
